import { useCallback, useEffect, useMemo, useState } from "react";
export const QUERY_KEYS = {
    SOURCE: "source",
    NO_GEO: "nogeoredirection",
    DEVICE_COUNTRY: "devicecountry",
    USER_COUNTRY: "usercountry",
    BYPASS: "location",
};
const DEVICE_KEY = "device";
/**
 * Hook for managing query params related to country selector.
 */
export const useSearchParamsConfig = () => {
    const [search, setSearch] = useState("");
    const [isSearchParamLoaded, setIsSearchParamLoaded] = useState(false);
    useEffect(() => {
        if (typeof window !== "undefined") {
            setSearch(window.location.search);
            setIsSearchParamLoaded(true);
        }
    }, []);
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const getParam = useCallback((key) => {
        return params.get(key);
    }, [params]);
    const paramsValues = useMemo(() => {
        const source = getParam(QUERY_KEYS.SOURCE);
        const noGeo = getParam(QUERY_KEYS.NO_GEO) !== null;
        const deviceCountry = getParam(QUERY_KEYS.DEVICE_COUNTRY);
        const userCountry = getParam(QUERY_KEYS.USER_COUNTRY);
        const bypass = getParam(QUERY_KEYS.BYPASS);
        return {
            source,
            noGeo,
            deviceCountry,
            userCountry,
            bypass,
            isDeviceSource: source === DEVICE_KEY,
        };
    }, [getParam]);
    return {
        search,
        isSearchParamLoaded,
        ...paramsValues,
    };
};
//# sourceMappingURL=useSearchParamsConfig.js.map